import React from 'react';
import Skeleton from './Skeleton';

interface LoadingCardProps {
  title?: string;
  message?: string;
}

const LoadingCard: React.FC<LoadingCardProps> = ({ 
  title = 'Loading', 
  message = 'Loading data...' 
}) => {
  return (
    <div className="theme-card rounded-lg shadow-sm p-4 relative border theme-border">
      {title && (
        <div className="mb-4">
          <Skeleton variant="text" width="40%" height={20} className="mb-2" />
        </div>
      )}
      <div className="space-y-3">
        <Skeleton variant="text" width="90%" height={16} />
        <Skeleton variant="text" width="80%" height={16} />
        <Skeleton variant="text" width="85%" height={16} />
      </div>
      <div className="mt-4 flex justify-end">
        <Skeleton variant="rounded" width={80} height={32} />
      </div>
    </div>
  );
};

export default LoadingCard;
